import { ComponentProps, useState } from 'react';

import { ButtonScanner } from './ButtonScanner';
import { PopupInputCode } from './PopupInputCode';
import { BarcodeScanner } from './scanner';
import { useBarcodeScanner } from './use-barcode-scanner';

type PropsPopup = Omit<
	ComponentProps<typeof PopupInputCode>,
	'onInput' | 'setActive'
>;

interface scannerProps {
	loading?: boolean;
	showButton?: boolean;
	onRead: (value: string) => void;
	type?: 'barcode' | 'qrcode';
	defaultMode?: 'popup' | 'scanner';
	iconOnly?: boolean;
	className?: string;
	popup?: PropsPopup;
}

export function Scanner({
	showButton = true,
	onRead,
	loading = false,
	type = 'barcode',
	iconOnly = false,
	className,
	popup,
	defaultMode = 'scanner',
}: scannerProps) {
	const [active, setActive] = useState<false | 'popup' | 'scanner'>(false);
	useBarcodeScanner((code) => {
		onScannerRead(code);
	});

	function handleClick(mode: 'popup' | 'scanner') {
		if (showButton) {
			switch (mode) {
				case 'popup':
					setActive('popup');
					break;
				case 'scanner':
					setActive('scanner');
					break;
			}
			// const barcodes = ['7891000325858', '7896098900208','7896020470427'];
			// onRead(barcodes[Math.floor(Math.random() * barcodes.length)]);
		}
	}

	function onScannerRead(value: string) {
		setActive(false);
		onRead(value);
	}

	return (
		<>
			{showButton && (
				<ButtonScanner
					activeScanner={active !== false}
					iconOnly={iconOnly}
					loading={loading}
					onClick={handleClick}
					type={type}
					className={className}
					mode={active ? active : defaultMode}
				/>
			)}
			<PopupInputCode
				{...popup}
				onInput={onScannerRead}
				isOpen={active === 'popup'}
				setActive={setActive}
			/>
			<BarcodeScanner
				onRead={onScannerRead}
				activeScanner={active === 'scanner'}
				type={type}
				setActiveScanner={setActive}
			/>
		</>
	);
}
